import React, {Component} from "react"
import PropTypes from "prop-types"
import {Link} from 'react-router-dom'
import {Badge, ButtonToolbar, Col, Glyphicon, Panel, Row} from "react-bootstrap"
import {Date, Enums, Grid} from "../../utils/index"
import {ExitTypeLabel, IntakeTypeLabel, PartyType} from "../../utils/enums";
import {formatExitDescription, formatIntakeDescription} from "../../utils/format";

class PartyDetail extends Component {

	getStatusTitle(value) {
		switch (value) {
			case "NEW":
				return <span><Glyphicon glyph="star" title="Nepotvrzený"/> Nepotvrzený</span>;
			case "ACTIVE":
				return <span><Glyphicon glyph="ok" title="Aktivní"/> Aktivní</span>;
			case "DELETED":
				return <span><Glyphicon glyph="remove" title="Smazaný"/> Smazaný</span>;
			default:
				return value
		}
	}

	getAddressTitle(address) {
		if (!address) {
			return null
		}
		const p = [];
		if (address.street) {
			p.push(address.street);
		}
		if (address.city) {
			p.push(address.city);
		}
		if (address.zip) {
			p.push(address.zip);
		}
		return p.join(', ');
	}


	render() {
		const {isFetchingItem, item, intakesPage, exitsPage, enums} = this.props;

		if (isFetchingItem || item === null) {
			return Grid.renderIsFetchingData()
		}
		const hasLegal = (item.legalParty && item.legalParty.partyId)
			|| item.partyType === PartyType.PO
			|| Date.getAge(item.birthDate) < 18;
		const legalParty = hasLegal ? (item.legalParty || {}) : {};
		const legalTitle = item.partyType === PartyType.PO ? 'Zastupující osoba' : 'Zákonný zástupce';
		const permAddressTitle = item.partyType === PartyType.PO ? 'Adresa sídla' : 'Adresa bydliště';

		return <div className={"detail"}>
			<Row key={1}>
				<Col lg={6}>
					<Panel>
						<Panel.Heading>
							{item.partyType === PartyType.PO ? 'Organizace' : 'Osoba'} <Badge className="pull-right">{item.partyId}</Badge>
						</Panel.Heading>
						<Panel.Body>
							<table className="table table-detail">
								<colgroup>
									<col width="15%"/>
									<col width="30%"/>
									<col width="15%"/>
									<col width="15%"/>
									<col width="25%"/>
								</colgroup>
								<tbody>
								<tr>
									{item.partyType === PartyType.PO ? <th>Název</th> : <th>Jméno</th>}
									{item.partyType === PartyType.PO ? <td>{item.companyName}</td> : <td>{item.firstName}</td>}
									<th>Email</th>
									<td>{item.email}</td>
								</tr>
								<tr>
									{item.partyType === PartyType.PO ? <th>IČ</th> : <th>Příjmení</th>}
									{item.partyType === PartyType.PO ? <td>{item.companyNumber}</td> : <td>{item.lastName}</td>}
									<th>Telefon</th>
									<td>{item.phone}</td>
								</tr>
								{item.partyType !== PartyType.PO && <tr>
									<th>Dat. nar.</th>
									<td>{Date.formatDate(item.birthDate)}</td>
								</tr>}
								<tr>
									<th>{permAddressTitle}</th>
									<td colSpan={4}>{this.getAddressTitle(item.permAddress)}</td>
								</tr>
								<tr>
									<th>Korespondenční</th>
									<td colSpan={4}>{this.getAddressTitle(item.mailAddress)}</td>
								</tr>
								{item.partyType !== PartyType.PO && <tr>
									<th>Market. souhlas</th>
									<td colSpan={4}>{item.isNewsletter ? "Ano" : "Ne"}</td>
								</tr>}
								<tr>
									<th>Stav</th>
									<td>{this.getStatusTitle(item.status)}</td>
								</tr>
								{hasLegal && <tr>
									<td colSpan={5}><h5 className="divider">{legalTitle}</h5></td>
								</tr>}
								{hasLegal && <tr>
									<th>Jméno</th>
									<td>{legalParty.firstName}</td>
								</tr>}
								{hasLegal && <tr>
									<th>Příjmení</th>
									<td>{legalParty.lastName}</td>
									<th>Telefon</th>
									<td>{legalParty.phone}</td>
								</tr>}
								{hasLegal && <tr>
									<th>Adresa</th>
									<td colSpan={4}>{this.getAddressTitle(legalParty.permAddress)}</td>
								</tr>}
								</tbody>
							</table>
						</Panel.Body>
					</Panel>
				</Col>
				<Col lg={6}>
					<Row>
						<Col lg={12}>
							<Panel>
								<Panel.Heading>
									Příjmy
								</Panel.Heading>
								<Panel.Body>
									<table className="table table-striped">
										<colgroup>
											<col width="15%"/>
											<col width="15%"/>
											<col width="20%"/>
											<col width="50%"/>
										</colgroup>
										<tbody>
										{intakesPage && intakesPage.items && intakesPage.items.length
											? intakesPage.items.map((item) => {
												return <tr key={item.intakeId}>
													<td>
														<Link to={{pathname: "/psi/" + item.dogId}}>{Enums.getEnumTitle(enums, 'dogAll', item.dogId)}</Link>
													</td>
													<td>
														{Date.formatDate(item.intakeAt)}<br/>
														{item.dogNumber && '#' + item.dogNumber}<br/>
														{item.dogName && ' (' + item.dogName + ')'}
													</td>
													<td>{IntakeTypeLabel[item.intakeType]}</td>
													<td>{formatIntakeDescription(item)}</td>
												</tr>
											}) : <tr>
												<td colSpan={5} className="text-center text-muted">Nenalezeny žádné záznamy</td>
											</tr>}
										</tbody>
									</table>
								</Panel.Body>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<Panel>
								<Panel.Heading>
									Výdaje
								</Panel.Heading>
								<Panel.Body>
									<table className="table table-striped">
										<colgroup>
											<col width="15%"/>
											<col width="15%"/>
											<col width="20%"/>
											<col width="50%"/>
										</colgroup>
										<tbody>
										{exitsPage && exitsPage.items && exitsPage.items.length > 0
											? exitsPage.items.map((item) => {
												return <tr key={item.exitId}>
													<td>
														<Link to={{pathname: "/psi/" + item.dogId}}>{Enums.getEnumTitle(enums, 'dogAll', item.dogId)}</Link>
													</td>
													<td>
														{Date.formatDate(item.exitAt)}<br/>
													</td>
													<td>{ExitTypeLabel[item.exitType]}</td>
													<td>{formatExitDescription(item)}</td>
												</tr>
											}) : <tr>
												<td colSpan={5} className="text-center text-muted">Nenalezeny žádné záznamy</td>
											</tr>}
										</tbody>
									</table>
								</Panel.Body>
							</Panel>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row>
				<Col sm={12} className="text-center">
					<ButtonToolbar>
						<Link to={{pathname: "/vencitele/" + item.partyId + "/uprava"}} className="btn btn-success"><Glyphicon glyph="pencil"/> Upravit osobu</Link>
					</ButtonToolbar>
				</Col>
			</Row>
		</div>
	}
}

PartyDetail.propTypes = {
	item: PropTypes.object,
	isFetchingItem: PropTypes.bool.isRequired,
	intakesPage: PropTypes.object,
	exitsPage: PropTypes.object,
	onFetchEnums: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

export default PartyDetail



// WEBPACK FOOTER //
// ./src/components/party/PartyDetail.js